import { render, staticRenderFns } from "./AlertesModal.vue?vue&type=template&id=904e527a"
import script from "./AlertesModal.vue?vue&type=script&lang=ts"
export * from "./AlertesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports